const SHOP_TRACKING_ENDPOINTS = {
    SHOP_VISITS: "/frontend/shop/track-visit",
    PRODUCT_VIEW: "/frontend/shop/track-product-view",
    PRODUCT_ADDED_IN_CART: "/frontend/shop/track-event",

};

export default SHOP_TRACKING_ENDPOINTS;